var map = {
	"./quick_read_1.jpg": 914,
	"./quick_read_2.jpg": 843,
	"./quick_read_3.jpg": 474,
	"./quick_read_4.jpg": 398,
	"./quick_read_5.jpg": 898,
	"./quick_read_6.jpg": 555
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 885;